<template>
  <Modal
    :show="show"
    width="medium"
    hide-default-actions
    @close="close"
  >
    <template #title>
      Create New Profile Template
    </template>

    <template #content>
      <CreateProfileTemplateForm
        ref="templateForm"
        @created="onCreated"
      />
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import CreateProfileTemplateForm from '@/components/shared/CreateProfileTemplateForm.vue';
import Modal from '@/components/shared/Modal.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { JP_PAGE_TEMPLATES_LIBRARY } from '@/helpers/jobProfileLibraryTracking';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);

const router = useRouter();
const route = useRoute();
const templateForm = ref(null);

const close = () => {
  templateForm.value?.resetForm();

  emit('close');
};

const onCreated = ({ template_ulid: templateUlid }) => {
  if (route.name === 'job-profile-templates') {
    useTracking().jpLibCreatedTemplate({ page: JP_PAGE_TEMPLATES_LIBRARY });
  }

  router.replace({
    name: 'job-profile-view',
    params: { id: templateUlid },
  });
  close();
};
</script>
